var LoadingAnimation;

import getSerializableGym from 'helpers/get_serializable_gym';

angular.module('gym', [
  'ngSanitize',
  'ngTable',
  'ui.router',
  'ui.bootstrap',
  'ui.bootstrap.dropdownSelect',
  'ui.sortable',
  'ui.timepicker',
  'angular-flash.service',
  'angular-flash.flash-alert-directive',
  'colorpicker.module',
  'model',
  'gym.form',
  'gym.contactForm',
  'gym.user',
  'gym.website',
  'gym.form-library',
  'gym.membership-plans',
  'gym.memberships',
  'gym.contacts',
  'gym.users',
  'gym.eventOccurrance',
  'gym.classroom',
  'gym.calendar',
  'gym.dashboard',
  'gym.invoices',
  'gym.templates',
  'gym.subscription',
  // TODO: delete
  'gym.subscriptions',
  'gym.components',
  'gym.registration',
  'gym.reports',
  'gym.tasks',
  'gym.bulkMessages',
  'gym.setup',
  'gym.pos',
  'gym.grading',
  'gym.waivers',
  'gym.sequences',
  'gym.workouts',
  'gym.mobile_app',
  'gym.access_control',
  'gym.integrations',
  'gym.profile',
  'gym.apiDetails',
  'gym.availability',
  'gym.privacy_policies',
  'gym.payouts',
  'gym.gocardless',
  'gym.payers',
  'gym.data_series',
  'gym.bulkImports',
  'gym.bulkUpdates',
  'gym.whats_new',
  'filters',
  'textAngular',
  'duScroll',
  'file-model',
  'restangular',
  'infinite-scroll',
  'ngTagsInput',
  'httpInterceptors',
  'shared',
  'signature',
  'angular-clipboard',
  'tandibar/ng-rollbar',
  'ngMask',
  'react',
  'actionCable',
  'ngMap'
]).config(["$httpProvider", "$locationProvider", "$stateProvider", "RollbarProvider", function($httpProvider, $locationProvider, $stateProvider, RollbarProvider) {
  $httpProvider.interceptors.push('http401Interceptor');
  $httpProvider.interceptors.push('jsonApiInterceptor');
  $httpProvider.defaults.xsrfHeaderName = 'X-CSRF-Token';
  $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
  $locationProvider.html5Mode(true);
  RollbarProvider.init(window._rollbarConfig);
  return $stateProvider.state('gym', {
    url: '/gyms/:gymId',
    controller: 'GymCtrl',
    resolve: {
      gym: ["$stateParams", "$rootScope", "Gym", function($stateParams, $rootScope, Gym) {
        return $rootScope.wrappedGym || Gym.find($stateParams.gymId);
      }]
    }
  }).state('gym.edit', {
    url: '/edit?tab&type&dashlet',
    reloadOnSearch: false,
    controller: 'GymProfileCtrl',
    template: require('templates/gyms/gym_profile/index.html.slim')
  });
}]).run(["$rootScope", "$window", "loadingAnimation", "Restangular", "restangularInterceptors", function($rootScope, $window, loadingAnimation, Restangular, restangularInterceptors) {
  loadingAnimation.hide();
  $rootScope.$on('$stateChangeStart', function(event, toState, toParams) {
    var confirmMessage;
    confirmMessage = $rootScope.stateChangeConfirmMessage;
    if (confirmMessage && !$window.confirm(confirmMessage)) {
      event.preventDefault();
      return;
    } else {
      $rootScope.stateChangeConfirmMessage = void 0;
      $window.onbeforeunload = void 0;
    }
    $rootScope.toParams = toParams;
    return loadingAnimation.show();
  });
  $rootScope.$on('$stateChangeSuccess', function() {
    angular.element('.devise-message.flash-danger').hide();
    loadingAnimation.hide();
    return window.scrollTo(0, 0);
  });
  $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error) {
    return loadingAnimation.hide();
  });
  $rootScope.$on('$statNotFound', function() {
    return loadingAnimation.hide();
  });
  return Restangular.addRequestInterceptor(restangularInterceptors.RequestInterceptor).addResponseInterceptor(restangularInterceptors.ResponseInterceptor);
}]).controller('GymCtrl', ["gym", "$scope", "$rootScope", "$state", "$location", "$stateParams", "$log", "$window", "$timeout", "ReactModal", "EmploymentService", "flash", "$http", "CwStorage", "WaiverReviews", "LoadDebouncedWaiverReviewsPendingCountService", "LoadInterruptionRequestsService", "LoadDebouncedDueTasksService", "DebouncedUnreadRepliesService", "LoadDebounceMobileAppMetaService", "LoadDebouncePendingAccessRequestsService", "UnreadChangelogEntriesService", "FeatureAvailabilityService", "GTMService", "TasksService", "MasqueradingService", "AdminUserService", "KioskService", "PageSettingsService", "AssetLibraryService", "MobileApp", function(gym, $scope, $rootScope, $state, $location, $stateParams, $log, $window, $timeout, ReactModal, EmploymentService, flash, $http, CwStorage, WaiverReviews, LoadDebouncedWaiverReviewsPendingCountService, LoadInterruptionRequestsService, LoadDebouncedDueTasksService, DebouncedUnreadRepliesService, LoadDebounceMobileAppMetaService, LoadDebouncePendingAccessRequestsService, UnreadChangelogEntriesService, FeatureAvailabilityService, GTMService, TasksService, MasqueradingService, AdminUserService, KioskService, PageSettingsService, AssetLibraryService, MobileApp) {
  var getContactsPageSettings, getDefaultContactList, getDefaultTasksList, getSidebarOpenDefaultValue, loadDueTasks, loadInterruptionRequestAvailability, loadInterruptionRequestCount, loadMobileAppMeta, loadPendingAccessRequests, loadUnreadChangelogEtries, loadWaiverReviewCount, ref;
  $rootScope.wrappedGym = gym;
  $scope.gym = $rootScope.gym = gym.attributes;
  $scope.serializableGym = $rootScope.serializableGym = getSerializableGym($scope.gym);
  $scope.permissions = EmploymentService.get().permissions;
  if ($location.search().notice) {
    flash.error = $location.search().notice;
  }
  GTMService.track();
  $scope.currentUser = window.currentUser;
  $scope.isMasquerading = MasqueradingService.isMasquerading();
  $scope.adminHasPermission = AdminUserService.has;
  $scope.isSidebarAlwaysVisible = function() {
    return window.innerWidth > 1200;
  };
  getSidebarOpenDefaultValue = function() {
    var ref;
    return ((ref = $state.current.name) !== 'gym.setup') && $scope.isSidebarAlwaysVisible();
  };
  $scope.isLeftMenuOpen = getSidebarOpenDefaultValue();
  window.addEventListener('resize', _.throttle(function() {
    return $timeout(function() {
      if ($scope.isLeftMenuOpen) {
        return;
      }
      return $scope.isLeftMenuOpen = getSidebarOpenDefaultValue();
    });
  }, 700));
  $scope.isCleanLayout = (ref = $state.current.name) === 'gym.setup';
  $scope.toggleLeftMenu = function(val = !$scope.isLeftMenuOpen) {
    return $scope.isLeftMenuOpen = val;
  };
  $scope.$watch('isLeftMenuOpen', function(open) {
    return angular.element('body').toggleClass('body--sidebar-open', open);
  });
  $scope.openVerificationModal = function() {
    return ReactModal.open({
      component: 'VerifyEmailModal'
    });
  };
  $scope.onSidebarItemClick = function() {
    if ($scope.isLeftMenuOpen && !$scope.isSidebarAlwaysVisible()) {
      $scope.toggleLeftMenu(false);
    }
    if ($state.is('gym.reports.list')) {
      return $scope.$emit('reports:list:clearTags');
    }
  };
  $rootScope.$on('$stateChangeStart', function(event, toState, toParams) {
    if ($scope.isLeftMenuOpen && !$scope.isSidebarAlwaysVisible()) {
      return $scope.toggleLeftMenu(false);
    }
  });
  $rootScope.defaultCalendarView = (function() {
    switch ($scope.gym.gym_config.internal_calendar_default_view) {
      case 'weekly_agenda':
        return 'gym.weeklyAgenda';
      case 'weekly_trainer':
        if ($scope.permissions.manage_other_contacts) {
          return 'gym.weeklyTrainers';
        } else {
          return 'gym.calendar';
        }
        break;
      default:
        return 'gym.calendar';
    }
  })();
  // datepicker config
  $scope.datePicker = {
    format: 'dd/MM/yyyy',
    open: false
  };
  $scope.secondaryDatePicker = {
    format: 'dd/MM/yyyy',
    open: false
  };
  $scope.openDatepicker = function(event, datePicker) {
    event.preventDefault();
    event.stopPropagation();
    datePicker || (datePicker = $scope.datePicker);
    return datePicker.open = true;
  };
  $scope.hide = function(event, type) {
    if (type === 'trial-reminder') {
      CwStorage.setItem('hideTrialNotice', true);
    }
    if (type === 'freemium-member-limit-reminder') {
      CwStorage.setItem('hideFreemiumOverMemberLimitNotice', true);
    }
    $(event.target).parents(".alert").hide();
  };
  getDefaultContactList = function() {
    return CwStorage.getItem('defaultContactList') || 'members';
  };
  $rootScope.defaultContactList = getDefaultContactList();
  $rootScope.$on('contacts:list:opened', function() {
    return $rootScope.defaultContactList = getDefaultContactList();
  });
  getDefaultTasksList = function() {
    return CwStorage.getItem('defaultTasksList');
  };
  $rootScope.defaultTasksList = getDefaultTasksList();
  $rootScope.$on('tasks:list:opened', function() {
    return $rootScope.defaultTasksList = getDefaultTasksList();
  });
  $scope.showTrialNotice = !CwStorage.getItem('hideTrialNotice');
  $scope.showFreemiumOverMemberLimitNotice = !CwStorage.getItem('hideFreemiumOverMemberLimitNotice');
  $scope.toggleSidebarDropdown = function(section) {
    return $scope.toggleLeftMenu(true);
  };
  $scope.isCurrentState = function() {
    return _.find(arguments, function(state) {
      return $state.current.name === state;
    });
  };
  $scope.isStateActive = function() {
    return _.find(arguments, function(state) {
      return $state.includes(state);
    });
  };
  $scope.onKioskModeClick = function() {
    return KioskService.enterKioskMode();
  };
  $scope.onClassKioskModeClick = function() {
    return KioskService.enterClassKioskMode();
  };
  $scope.onRollCallClick = function(event) {
    if (!$scope.permissions.roll_call) {
      return;
    }
    if (event.metaKey || event.ctrlKey) {
      event.preventDefault();
      return $window.open($scope.rollCallUrl, "_blank");
    } else {
      return KioskService.enterRollCall();
    }
  };
  $scope.rollCallUrl = `/gyms/${$scope.gym.id}/roll_call/enter`;
  $scope.selectGym = function(gym) {
    if (MasqueradingService.isMasquerading()) {
      return;
    }
    return $http.put(`/head_office/masquerades/${gym.id}`).then(function(response) {
      var url;
      url = response.data.redirect_path;
      $window.open(url, '_self');
      return true;
    });
  };
  $scope.isFeatureAvailable = function(feature) {
    return FeatureAvailabilityService.isAvailable(feature);
  };
  $scope.showFeatureNotAvailableMessage = function(feature) {
    return FeatureAvailabilityService.showNotAvailableMessage(feature);
  };
  $scope.addTask = function() {
    $scope.onSidebarItemClick();
    GTMService.trackPage('View Tasks', 'Add');
    return TasksService.create();
  };
  $scope.toggleAssetLibrary = function() {
    return AssetLibraryService.open({
      mode: 'manage'
    });
  };
  $rootScope.setAppFooterVisible = function(value) {
    return $rootScope.appFooterHidden = !value;
  };
  getContactsPageSettings = function() {
    var pageId;
    pageId = (function() {
      switch ($rootScope.defaultContactList) {
        case 'members':
          return 'member_list';
        case 'prospects':
          return 'prospect_list';
        case 'non_attending_contacts':
          return 'nac_list';
      }
    })();
    return PageSettingsService.preload(pageId, {
      withMeta: true
    });
  };
  getContactsPageSettings();
  $rootScope.$on('waivers:reviews:loaded', function(event, count) {
    return $rootScope.waiverPendingReviewsCount = count;
  });
  $rootScope.$on('contacts:states:loaded', function(event, count) {
    return $rootScope.membershipInterruptionRequestCount = count;
  });
  DebouncedUnreadRepliesService.load().then(function(data) {
    $rootScope.unreadReplyCount = data.unread_reply_count;
    return $scope.$emit('unread_replies:loaded', data.unread_reply_count);
  });
  loadWaiverReviewCount = function() {
    var ref1;
    if ((ref1 = $scope.gym.gym_waiver_detail) != null ? ref1.enabled : void 0) {
      return LoadDebouncedWaiverReviewsPendingCountService.load().then(function(data) {
        $rootScope.waiverPendingReviewsCount = data.pending_review_count;
        return $scope.$emit('waivers:reviews:loaded', data.pending_review_count);
      });
    }
  };
  loadWaiverReviewCount();
  loadInterruptionRequestCount = function() {
    return LoadInterruptionRequestsService.load().then(function(data) {
      $rootScope.membershipInterruptionRequestCount = data.pending_count;
      return $scope.$emit('contacts:states:loaded', data.pending_count);
    });
  };
  $rootScope.interruptionRequestsAvailable = false;
  loadInterruptionRequestAvailability = function() {
    if ($scope.gym.mobile_app_enabled) {
      return MobileApp.all('settings').getList().then(function(settings) {
        var data;
        data = settings[0];
        $rootScope.interruptionRequestsAvailable = data.custom_app || (data.features_disabled || []).indexOf('cancellation_requests') === -1;
        if ($rootScope.interruptionRequestsAvailable) {
          return loadInterruptionRequestCount();
        }
      });
    }
  };
  loadInterruptionRequestAvailability();
  $rootScope.$on('waivers:reviews:reload', function() {
    return loadWaiverReviewCount();
  });
  $rootScope.$on('contacts:states:reload', function() {
    if ($rootScope.interruptionRequestsAvailable) {
      return loadInterruptionRequestCount();
    }
  });
  loadDueTasks = function() {
    return LoadDebouncedDueTasksService.load({
      count: 1
    }).then(function(tasks) {
      return $scope.dueTasksCount = tasks.meta.total;
    });
  };
  $scope.messagesRoute = (function() {
    switch (false) {
      case !$scope.permissions.send_bulk_comms:
        return 'gym.bulkMessages.new';
      case !$scope.permissions.view_comms_templates:
        return 'gym.templates.list';
      default:
        return 'gym.bulkMessages.sent_messages';
    }
  })();
  $scope.gradingsRoute = (function() {
    switch (false) {
      case !$scope.permissions.manage_styles_and_ranks:
        return 'gym.grading.styles.list';
      case !$scope.permissions.perform_grading:
        return 'gym.grading.gradings.new';
      default:
        return 'gym.grading.gradings.list';
    }
  })();
  $scope.salesRoute = (function() {
    switch (false) {
      case !$scope.permissions.create_pos_sales:
        return 'gym.pos.sales.new';
      case !$scope.permissions.view_pos_sales:
        return 'gym.pos.sales.list';
      case !$scope.permissions.manage_pos_reconciliations:
        return 'gym.pos.reconciliations';
      default:
        return 'gym.pos.products.list';
    }
  })();
  loadDueTasks();
  $rootScope.$on('tasks:updated', function() {
    return loadDueTasks();
  });
  loadUnreadChangelogEtries = function() {
    return UnreadChangelogEntriesService.load().then(function(data) {
      return $rootScope.unreadChangelogEntriesCount = data.unread_count;
    });
  };
  loadUnreadChangelogEtries();
  $rootScope.$on('changelog:unread:updated', function() {
    return loadUnreadChangelogEtries();
  });
  loadMobileAppMeta = function() {
    if ($scope.gym.mobile_app_enabled) {
      return LoadDebounceMobileAppMetaService.load().then(function(data) {
        return $rootScope.mobileAppMeta = data;
      });
    } else {
      return $rootScope.mobileAppMeta = {};
    }
  };
  loadMobileAppMeta();
  $rootScope.$on('mobile_app:meta:reload', function() {
    return loadMobileAppMeta();
  });
  loadPendingAccessRequests = function() {
    if ($scope.gym.mobile_app_enabled) {
      return LoadDebouncePendingAccessRequestsService.load().then(function(data) {
        return $rootScope.pendingAccessRequestsCount = data;
      });
    }
  };
  loadPendingAccessRequests();
  $rootScope.$on('access_requests:pending_count:updated', function(event, count) {
    return $rootScope.pendingAccessRequestsCount = count;
  });
  return $rootScope.$on('access_requests:pending_count:reload', function() {
    return loadPendingAccessRequests();
  });
}]).factory('Gym', [
  'Model',
  'Form',
  'ContactForm',
  'User',
  'MembershipPlanCategory',
  'EventOccurrance',
  'Classroom',
  'Website',
  function(Model,
  Form,
  ContactForm,
  User,
  MembershipPlanCategory,
  EventOccurrance,
  Classroom,
  Website) {
    var Gym;
    return Gym = (function() {
      // coffeelint: disable
      class Gym extends Model {
        constructor() {
          //TODO: PERFORMANCE -> this is expecting (maybe reloading) the world. Simmer down.
          super(...arguments);
          this.users = this.wrapCollection('users', Model);
          this.forms = this.wrapCollection('form_sections', Form);
          this.prospectForms = this.wrapCollection('prospect_forms', ContactForm);
          this.memberForms = this.wrapCollection('member_forms', ContactForm);
          this.nonAttendingContactForms = this.wrapCollection('non_attending_contact_forms', ContactForm);
          this.membershipPlanCategories = this.wrapCollection('membership_plan_categories', MembershipPlanCategory);
          this.events = this.wrapCollection('events', EventOccurrance);
          this.classrooms = this.wrapCollection('classrooms', Classroom);
          this.website = this.wrap('website', Website);
        }

        formWithField(name) {
          return this.forms().find_by(function(form) {
            return form.fields().where({
              name: name
            });
          });
        }

      };

      Gym.path = '/gyms/:id';

      return Gym;

    }).call(this);
  }
// coffeelint: enable
]).provider('loadingAnimation', LoadingAnimation = class LoadingAnimation {
  $get() {
    return new LoadingAnimation();
  }

  animationDiv() {
    return $('.worx-loading-background');
  }

  show() {
    return this.animationDiv().removeClass('hidden');
  }

  hide() {
    return this.animationDiv().addClass('hidden');
  }

});

angular.module("gym").directive("highlightTableRow", function() {
  return {
    link: function($scope, element, attrs) {
      return $(element).click(function() {
        $("tr").removeClass("just-now");
        return $(element).closest("tr").addClass("just-now");
      });
    }
  };
});
